import React, { useEffect } from 'react'
import styles from './style.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { setTheme } from '../../Store/Slices/languageSelectorSlice'


function  ThemeToggler() {
  
    const dispatch=useDispatch()
    const theme =useSelector((state)=>state.theme.theme)
    // console.log("theme from store",theme);

    const toggleButton = (value) => {
        // console.log("Toggle", value);
        dispatch(setTheme(value))
        themeChecker(value)         
    }

    const themeChecker=(flag)=>{      
        if (flag === true) {
            document.documentElement.setAttribute('data', 'theme-light');          
        } else {
            document.documentElement.setAttribute('data', 'theme-dark');
        }
     
        localStorage.setItem("theme", flag)
    }
  useEffect(()=>{
    themeChecker(theme)
  },[theme])
 
    return (
        <>
            <div onClick={() => toggleButton(!theme)} className={theme ? [`${styles.mode} ${styles.ratioLeft} ${styles.light}`] : [`${styles.mode} ${styles.ratioRight} ${styles.dark}`]}></div>
        </>
    )
}

export default ThemeToggler